import './index.css';
import useTheme from '../../utilities/hooks/theme';
import Constants from '../../constants';
import I18n from '../../utilities/locale';
import View from '../view';
import Text from '../text';
import React from 'react';

interface Props {
  message?: string;
}

const EmptyData = ({ message }: Props) => {
  const { EmptyDataTheme: theme } = useTheme();
  const messageColor = {
    color: theme.emptyMessage
  };
  return (
    <View className="empty-data-container">
      <Constants.Svgs.Empty width={'80px'} height={'80px'} fill={theme.emptyIcon} />
      <Text style={messageColor} className="empty-data-message">
        {message}
      </Text>
    </View>
  );
};
EmptyData.defaultProps = {
  message: I18n.t('NoDataFound')
};
export default React.memo(EmptyData);
